window.initializeFlatPickr = function(){
  flatpickr("input[type=time]", { enableTime: true, noCalendar: true, time_24hr: true });
}
